import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-black text-white/60 font-cinzel text-sm tracking-widest">LOADING</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
